import React from 'react';

import { FlexBoxRow as Row } from '@r1-frontend/ui-react/components/layouts/flexBoxGrid';

import AdaptiveNukaCarousel from '~/src/components/AdaptiveNukaCarousel';

import * as ST from './styled';

export interface IFeature {
    id: number | string,
    image: string,
    image_webp: string,
    icon: string,
    title: string,
    text: string,
    alt: string,
}

interface IProps {
    items: IFeature[],
    className?: string,
    showCarousel: boolean,
}

const Features: React.FC<IProps> = ({ items = [], className = '', showCarousel }): JSX.Element => {

    return (
        <ST.Wrapper className={className}>
            {
                !showCarousel
                    ? <Row>
                    {
                        items?.map((item) => {
                            return (
                                <ST.SCol
                                    key={item.id}
                                    lg={3}
                                    md={5}
                                    sm={5}
                                    xs={12}
                                >
                                    <ST.FeatureItem data-test='feature-item'>
                                        <ST.Image
                                            bgImage={item.image}
                                            bgWebpImage={item.image_webp}
                                            icon={item.icon}
                                            role='img'
                                            aria-label={item.alt}
                                            data-test='feature-item-image'
                                        />
                                        <ST.Desc>
                                            <ST.Title data-test='feature-item-title' dangerouslySetInnerHTML={{ __html: item.title }}/>
                                            <ST.Text data-test='feature-item-text' dangerouslySetInnerHTML={{ __html: item.text }}/>
                                        </ST.Desc>
                                    </ST.FeatureItem>
                                </ST.SCol>
                            );
                        })
                    }
                </Row>
                : <AdaptiveNukaCarousel
                    desktopSlideWidth='327'
                    withoutArrows
                    cellSpacing={24}
                    slidesToScroll={'auto'}
                    customDotsStyles={ST.customDotsStyles}
                    data-test='features-carousel'
                >
                {
                    items?.map((item) => {
                        return (
                            <ST.FeatureItem key={item.id} isSlide={true} data-test='feature-item'>
                                <ST.Image
                                    bgImage={item.image}
                                    bgWebpImage={item.image_webp}
                                    icon={item.icon}
                                    role='img'
                                    aria-label={item.alt}
                                    data-test='feature-item-image'
                                />
                                <ST.Desc>
                                    <ST.Title data-test='feature-item-title' dangerouslySetInnerHTML={{ __html: item.title }}/>
                                    <ST.Text data-test='feature-item-text' dangerouslySetInnerHTML={{ __html: item.text }}/>
                                </ST.Desc>
                            </ST.FeatureItem>

                        );
                    })
                }
                </AdaptiveNukaCarousel>
            }
        </ST.Wrapper>
    );
};

export default Features;
